/**
 * @file FontModeSwitch.tsx
 * @description Переключатель «[ По роли сайта | Свой шрифт ]» поля «Шрифт»
 * элемента (phase19.16, партия SB120 «свобода выбора», этап 0; site-builder.md
 * SB120; uiux-sb120-fields §4). Режим не хранится отдельно — он следует из
 * значения (`kind`); «Свой шрифт» открывает окно каталога, а запись — по
 * выбору шрифта в окне. Выключенное поле — оба варианта выключены, ни окно,
 * ни сброс не срабатывают.
 */

import { Segmented, type SegmentedOption } from "../../site-view/Segmented";

export type FontMode = "role" | "custom";

const MODE_OPTIONS: readonly SegmentedOption<FontMode>[] = [
  { value: "role", label: "По роли сайта" },
  { value: "custom", label: "Свой шрифт" },
];

interface Props {
  value: FontMode;
  /** Подпись поля для чтеца экрана: «Шрифт». */
  label: string;
  disabled?: boolean;
  onChange: (mode: FontMode) => void;
}

export function FontModeSwitch({ value, label, disabled, onChange }: Props) {
  const options = disabled ? MODE_OPTIONS.map((o) => ({ ...o, disabled: true })) : MODE_OPTIONS;
  // На 360 два сегмента делят ширину поровну — подписи не переносятся по слову.
  return (
    <Segmented
      aria-label={`${label}: откуда`}
      options={options}
      value={value}
      onChange={(mode) => !disabled && mode !== value && onChange(mode)}
      className="grid w-full grid-cols-2"
    />
  );
}
